"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE_NUMBER_PREFIXES = exports.USER_REPLACEMENT_REGEX = void 0;
exports.USER_REPLACEMENT_REGEX = {
    phone: /^(0|49|\+49)+|[^0-9]+/g,
    hash: /\s/g,
};
exports.PHONE_NUMBER_PREFIXES = {
    german: '49',
    e164: '+49',
};
